import { KeenSliderInstance } from 'keen-slider';
import { IconArrowSquareDown, IconArrowSquareUp } from '@/features/icons';
import { cn } from '@/utils/cn';
type Props = {
  direction: 'up' | 'down';
  onActiveIndexChange?: (index: number) => void;
  activeIndex: number;
  instanceRef: React.RefObject<KeenSliderInstance>;
  totalCount: number;
};
export const DesktopNavigationButtonHandler = ({
  direction,
  onActiveIndexChange,
  activeIndex,
  instanceRef,
  totalCount
}: Props) => {
  const handleArrowClick = (direction: 'up' | 'down') => {
    if (!onActiveIndexChange) return;
    const delta = direction === 'up' ? -1 : 1;
    const nextIndex = Math.min(totalCount - 1, Math.max(0, activeIndex + delta));
    if (nextIndex === activeIndex) return;
    onActiveIndexChange(nextIndex);
    if (instanceRef.current) {
      instanceRef.current.moveToIdx(nextIndex);
    }
  };
  const canScrollUp = activeIndex > 0;
  const canScrollDown = activeIndex < totalCount - 1;
  return <button type='button' onClick={() => handleArrowClick(direction)} disabled={direction === 'up' ? !canScrollUp : !canScrollDown} className={cn('my-1 flex h-6 w-6 items-center justify-center rounded-sm', (direction === 'up' ? canScrollUp : canScrollDown) ? 'bg-gray-100 text-black' : 'cursor-default bg-gray-50 text-text-mediumGray')} aria-label={`Scroll thumbnails ${direction}`} data-sentry-component="DesktopNavigationButtonHandler" data-sentry-source-file="desktop-navigation-button-handler.tsx">
            {direction === 'up' ? <IconArrowSquareUp className='h-5 w-5' /> : <IconArrowSquareDown className='h-5 w-5' />}
        </button>;
};